import React from 'react';

const FullscreenIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <g fill="#000" stroke="#000" strokeWidth=".25">
      <path d="M27.89 0v3.263h8.807v8.809h3.264V0zM0 27.89V39.96h12.072v-3.263H3.263V27.89zM0 0v12.072h3.263V3.263h8.809V0zM36.698 27.89v8.808h-8.809v3.263h12.072V27.89z" />
    </g>
  </svg>
);

export default FullscreenIcon;
